import React, { useEffect } from 'react';
import { get } from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MenuSideBar from 'components/SideBar';
import SearchBarAndTable from 'components/SearchAndTable';
import { currentViewName, ACTIVE_LISTINGS, INVENTORY, ORDERS } from 'utils/viewNames';
import { setViewAction } from 'store/actions/view';
import { getSearchResultsAction } from 'store/actions/search';
import { setCancelAction } from 'store/actions/cancel';
import { CancelModal } from 'components/CancelModal';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const Home = ({ location }) => {
  const view = currentViewName(location);
  const currentView = useSelector((state) => state.currentView);
  const currentOpenTab = useSelector((state) => state.openOrders.currentTab);
  const currentCompletedTab = useSelector((state) => state.completedOrders.currentTab);
  const cancel = useSelector((state) => state.cancel);
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(setCancelAction({ isOpen: false, order: null }));
  };

  useEffect(() => {
    dispatch(
      getSearchResultsAction(
        '',
        currentView === 'Open' ? currentOpenTab : currentCompletedTab,
        currentView,
      ),
    );
    dispatch(setViewAction(view));
  }, [view]);

  return (
    <Home.HomeContainer>
      <MenuSideBar view={view} />
      <Home.RightModule>
        <Home.PageTitle>
          {currentView === ACTIVE_LISTINGS ? INVENTORY : ORDERS}
          {view && <Home.MenuArrow src="/assets/images/icn-navigation-carrot.png" />}
          {view && <Home.PageTitle>{view}</Home.PageTitle>}
        </Home.PageTitle>
        <CancelModal
          modalVisible={cancel.isOpen}
          orderNumber={get('order.number')(cancel)}
          product={get('order.product')(cancel)}
          onCancel={handleCancel}
        />
        <SearchBarAndTable table={view} />
      </Home.RightModule>
    </Home.HomeContainer>
  );
};

Home.HomeContainer = styled.div`
  background-color: ${COLORS.primaryBackground};
  min-width: 100vw;
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  left: 0;
  top: 0;
  display: flex;
`;

Home.RightModule = styled.div`
  width: 100%;
  margin-left: 250px;
  margin-top: 32px;
  text-align: left;
  margin-right: 56px;
  padding-bottom: 30px;
`;

Home.PageTitle = styled.span`
  font-family: ${FONTS.default};
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;
  color: ${COLORS.secondaryText};

  span {
    color: ${COLORS.primaryText};
  }
`;

Home.MenuArrow = styled.img`
  margin: 0px 8px;
`;

Home.Placeholder = styled.div`
  height: 129px;
  width: 100%;
`;

Home.propTypes = {
  location: PropTypes.shape({
    match: PropTypes.string,
  }),
  category: PropTypes.string,
};

export default Home;
